import { axiosApigateway } from "../../../api";
import { axiosMsGraph } from "../../../api";
import { searchUserResources_actionType } from "../../actionTypes/userAction-actionTypes/searchUserResources-actionType";

export function resetSearchUserResources() {
  return {
    type: searchUserResources_actionType.RESET_SEARCH_USER_RESOURCES
  };
}

/* MS GRAPH API */
async function getAllUsersInGraph(data) {
  const toSelect = [
    "id",
    "displayName",
    "preferredLanguage",
    "country",
    "usageLocation",
    "officeLocation",
    "givenname",
    "surname",
    "jobtitle",
    "mail",
    "onPremisesSamAccountName",
    "onPremisesDomainName",
    "onPremisesImmutableId",
    "onPremisesLastSyncDateTime",
    "onPremisesUserPrincipalName",
    "employeeId"
  ].join(",");
  const orderBy = ["displayName", "mail"].join(",");
  const queryString = `$filter=employeeId ne null&$search="displayName: ${data}" OR "mail:${data}"&$select=${toSelect}&$orderby=${orderBy}&$count=true`;
  const finalURL = `/users?${queryString}`;
  return axiosMsGraph.get(finalURL);
}

/* DB API */
async function getAllUsersInDB(data) {
  console.log("search data in DB", data);
  const finalEndPoint = `/users?$search=*${data}*`;
  return axiosApigateway
    .get(finalEndPoint)
    .then((res) => res.data)
    .catch((err) => err);
}

// workday call for cost center
async function getUserFromWorkday(systemIdList) {
    // Prepare payload for Workday API call
    const requireworkData = { systemID: systemIdList };
    console.log("systemId in function", requireworkData);
    // Make API call to fetch Workday data
    const workdayResponse = await axiosApigateway.post('/workday-data', requireworkData);
    if (
        workdayResponse &&
        workdayResponse.data
      ) {
        console.log("CostCenterName", workdayResponse);
        return workdayResponse;
      } else {
        console.warn("No data in workday API response or CostCenterName not found");
        return "";
      }
}

async function getAllUserInBoth(data) {
  const combinedResponse = await Promise.all([
    getAllUsersInGraph(data),
    getAllUsersInDB(data)
  ]);

  let adUserList = combinedResponse[0]?.data?.value;
  let dbUserList = combinedResponse[1]?.data;
  let systemIdList = [];
  let adAndDbUserList = [];

  dbUserList.forEach((userDb) => {
    const adUser = adUserList.find(
      (userAd) => userAd?.mail?.toLowerCase() === userDb?.email?.toLowerCase()
    );
    const globalId = adUser ? adUser.employeeId : "";
    const systemId = userDb ? userDb.federated_id : "";
    systemIdList.push(systemId);
    adAndDbUserList.push({
      ...userDb,
      isExist: true,
      employeeId: globalId
    });
  });  
  
  adUserList.forEach((userAd) => {
    const adUserExist = dbUserList.find(
      (userDb) => userDb?.email?.toLowerCase() === userAd?.mail?.toLowerCase()
    );
    const systemId = userAd ? userAd.onPremisesSamAccountName : "";  
    systemIdList.push(systemId);
    if (!adUserExist) {
      adAndDbUserList.push({
        ...userAd,
        isExist: false
      });
    }
  });
  const workdayData = systemIdList ? await getUserFromWorkday(systemIdList) : "";  
  //map workday data with adAndDbUserList  
  if (workdayData && workdayData.data && Array.isArray(workdayData.data.data)) {
    adAndDbUserList = adAndDbUserList.map(user => {
      const federatedId = user.federated_id || user.onPremisesSamAccountName;
      // Find matching cost center info by systemId or federatedId      
      const CostCenterInfo = workdayData.data.data.find(
        item =>
          item.SystemLogonId === federatedId
      );      
      return {
        ...user,
        CostCenter: CostCenterInfo ? CostCenterInfo.CostCenter : "N/A",
        CostCenterName: CostCenterInfo ? CostCenterInfo.CostCenterName : "N/A"
      };
    });
  }  
  return adAndDbUserList;
}

export function searchUserResources(data) {
  return async (dispatch) => {
    dispatch({
      type: searchUserResources_actionType.SEARCH_USER_RESOURCES
    });
    try {
      const response = await getAllUserInBoth(data);
      if (response) {
        dispatch({
          type: searchUserResources_actionType.SEARCH_USER_RESOURCES_SUCCESS,
          payload: response
        });
      }
    } catch (error) {
      dispatch({
        type: searchUserResources_actionType.SEARCH_USER_RESOURCES_ERROR,
        payload: error || "Something went wrong, Please try after sometime!"
      });
    }
  };
}
